'use client'

import { createContext, PropsWithChildren, useCallback, useContext, useRef } from 'react'

type VideoPlaybackContextType = {
  registerRequestCurrentTime: (fn: () => Promise<number>) => void
  requestCurrentTime: () => Promise<number>
}

const VideoPlaybackContext = createContext<VideoPlaybackContextType | null>(null)

export function VideoPlaybackProvider({ children }: PropsWithChildren) {
  const fnRef = useRef<(() => Promise<number>) | null>(null)

  const registerRequestCurrentTime = useCallback((fn: () => Promise<number>) => {
    fnRef.current = fn
  }, [])

  const requestCurrentTime = useCallback((): Promise<number> => {
    return fnRef.current?.() ?? Promise.resolve(0)
  }, [])

  return (
    <VideoPlaybackContext.Provider value={{ registerRequestCurrentTime, requestCurrentTime }}>
      {children}
    </VideoPlaybackContext.Provider>
  )
}

export function useVideoPlaybackContext() {
  return useContext(VideoPlaybackContext)
}
